import * as React from 'react'
import NotificationsWrapper from '../../components/Notification/NotificationsWrapper'
import { CompanyId, GoalId, GoalWithProgress, Role, UserProfileDto } from '../../services/api.types'
import YumGoalListWrapper from '../../components/YumGoalList/YumGoalListWrapper'
import { PluginListenerHandle } from '@capacitor/core'
import { App } from '@capacitor/app'
import { isNative } from '../../common/helpers/isNative'

export interface IStateProps {
  hasRoleInCompany(companyId: CompanyId, role: Role): boolean
  goalId: GoalId | null
  token?: string
  goals: GoalWithProgress[]
  goalsDtoLoading: boolean
  userDto: UserProfileDto
}

export interface IDispatchProps {
  getCompanyDivisions(): void
  getUserCompanyCountries(): void
  getCurrentCompanyGoal(payload: { id?: GoalId | null; silentGoalUpdate?: boolean; token?: string | null }): void
  getCurrentGoalActivityListClear(payload?: { goalId: string; clearAll?: boolean }): void
}

type IActivityProps = IStateProps & IDispatchProps

export class Activity extends React.PureComponent<IActivityProps> {
  appStateChangeListener: PluginListenerHandle | undefined
  state = { showManualEntry: false }

  getChallenges() {
    console.log('Activity | getChallenges')
    const { token, goalId } = this.props

    if (token) {
      if (goalId) {
        this.props.getCurrentGoalActivityListClear({ goalId, clearAll: true })
        this.props.getCurrentCompanyGoal({ id: goalId, token })
      }
    } else {
      this.props.getUserCompanyCountries()
      this.props.getCompanyDivisions()
      this.props.getCurrentCompanyGoal({ id: this.props.goalId, silentGoalUpdate: true })
    }
  }

  async componentDidMount(): Promise<void> {
    /*const { token, goalId } = this.props

    // !!! REDIRECT TO NEW VIEW !!!
    if (goalId && !token) {
      store.dispatch(push(`/challenges/${goalId}/ranking`))
      return
    }*/

    this.getChallenges()

    if (isNative()) {
      this.appStateChangeListener = await App.addListener('appStateChange', async ({ isActive }) => {
        if (isActive) {
          console.log('Activity | APP RESUME | getChallenges')
          this.getChallenges()
        }
      })
    }
  }

  componentWillUnmount() {
    if (isNative() && this.appStateChangeListener) {
      try {
        this.appStateChangeListener.remove()
      } catch (error) {
        console.error('Activity | appStateChangeListener.remove() error', error)
      }
    }
  }

  render() {
    const { goals, goalsDtoLoading } = this.props

    return (
      <>
        <NotificationsWrapper />
        <YumGoalListWrapper goals={goals} loading={goalsDtoLoading} />
      </>
    )
  }
}
